<template>
  <ion-note slot="helper" class="w-full text-[10px] px-1 mt-1 ion-text-red block" v-if="props.error">
    {{ props.error }}
  </ion-note>
</template>
<script setup>
const props = defineProps(['error']);
</script>